import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import UserModal from "../../../shared/UserModal";
import {
  getUsersData,
  addUser,
  bulkDeleteGroupUsers,
} from "../../../services/userService";
import { Link } from "react-router-dom";
import loaderContext from "../../../../../../context/loader/loaderContext";
import SearchByInput from "../../../../../common/searchByInput";
import { toast } from "react-toastify";
import { Pager } from "../../../../shared/pager";
import { handleSortIconClick } from "../../../../../../helper/shared/sorting";
import { SortButton } from "../../../../../common/sortingTables";
import { filterItems } from "../../../../../../helper/shared/sorting";
import DeleteImportConfirmation from "../deleteImportConfirmation";

const UserOwnersMembers = (props) => {
  const { userList, isOwner, onRefreshData, securityGroupId } = props;
  const [currentUsers, setCurrentUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUserNames, setSelectedUserNames] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const selectAllRef = useRef(null);
  const [currentPageNbr, setCurentPageNbr] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [userCountList, setUserCountList] = useState([]);
  const [sortDirection, setSortDirection] = useState("");
  const [isShowDeleteConfirmation, setIsShowDeleteConfirmation] =
    useState(false);
  const defaultColumnName = "displayName";
  const ascending = "ascending";
  const noSort = "noSort";

  const [otherColumnDirection, setOtherColumnDirection] = useState(noSort);
  const [defaultColumnDirection, setDefaultColumnDirection] =
    useState(ascending);
  const [sortBy, setSortBy] = useState(defaultColumnName);
  const [currentColumnName, setCurrentColumnName] = useState("");
  const { updateLoaderStatus } = useContext(loaderContext);
  const usernameInputRef = useRef(null);
  const [showUserPopup, setShowUserPopup] = useState(false);
  const userRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const handleUserToggle = () => {
    setShowUserPopup((prevShowUserPopup) => !prevShowUserPopup);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      // Check if the click is outside both the menu and toggle button
      if (
        showUserPopup &&
        userRef.current &&
        !userRef.current.contains(e.target) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(e.target)
      ) {
        setShowUserPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showUserPopup]);

  useEffect(() => {
    if (selectAllRef.current) {
      if (selectedUsers.length > 0 && selectedUsers.length < userList.length) {
        selectAllRef.current.indeterminate = true;
      } else {
        selectAllRef.current.indeterminate = false;
      }
    }
  }, [selectedUsers, userList]);

  useEffect(() => {
    const searchValue = search?.toLowerCase().trim();
    const filteredUsers = userList?.filter(
      (user) =>
        user?.displayName?.toLowerCase().includes(searchValue) ||
        user?.UserName?.toLowerCase().includes(searchValue) ||
        user?.role?.toLowerCase().includes(searchValue)
    );

    const sortedUsers = [...(filteredUsers || [])].sort((a, b) =>
      a.displayName?.localeCompare(b?.displayName)
    );

    const sortConfig = {
      sortBy: sortBy || "displayName",
      direction: sortDirection || "ascending",
    };

    const sortedData = sortTableData(sortedUsers, sortConfig);

    const currentUsers = sortedData;
    setCurrentUsers(currentUsers);

    setUserCountList(currentUsers);
    const totalPages = Math.ceil(currentUsers?.length / currentPageSize);
    if (currentPageNbr > 1) {
      if (currentPageNbr > totalPages) {
        setCurentPageNbr(1);
      }
    }

    if (parseInt(currentPageSize) === -1) {
      setCurrentUsers([...currentUsers]);
    } else {
      const startIndex = (currentPageNbr - 1) * parseInt(currentPageSize);
      if (currentUsers?.length <= startIndex) {
        setCurrentUsers([...currentUsers]);
      } else {
        setCurrentUsers([
          ...currentUsers?.slice(
            startIndex,
            startIndex +
            parseInt(
              parseInt(currentPageSize) === -1
                ? currentUsers.length
                : currentPageSize
            )
          ),
        ]);
      }
    }
  }, [
    search,
    currentPageNbr,
    currentPageSize,
    userList,
    sortBy,
    sortDirection,
  ]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedUsers(userList.map((user) => user.userId));
    } else {
      setSelectedUsers([]);
    }
  };

  const handleSelectUser = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((uid) => uid !== id) : [...prev, id]
    );
  };
  const handleSelectedUserName = (UserName) => {
    setSelectedUserNames((prev) => {
      const exists = prev.find((user) => user.UserName === UserName);

      if (exists) {
        // Remove the entry if it already exists
        return prev.filter((user) => !(user.UserName === UserName));
      } else {
        // Add the new entry
        return [
          ...prev,
          { UserName, RoleType: isOwner ? "Owners" : "Members" },
        ];
      }
    });
  };

  const handleDelete = async () => {
    if (selectedUsers.length === 0) return;
    try {
      setIsShowDeleteConfirmation(true);
    } catch (error) {
      console.error("Error deleting users:", error);
    }
  };

  const removeUsers = async () => {
    updateLoaderStatus(true);
    try {
      const response = await bulkDeleteGroupUsers(selectedUserNames, securityGroupId);
      if (response?.data?.status_code === 200) {
        toast.success("User(s) Deleted successfully");
        setModalOpen(false);
        setSelectedUserNames([]);
        setSelectedUsers([]);
        onRefreshData();
        handleClosePopup();
        updateLoaderStatus(false);
      }
      else {
        toast.error("Error Deleting Users");
        setModalOpen(false);
        setSelectedUserNames([]);
        setSelectedUsers([]);
        onRefreshData();
        handleClosePopup();
        updateLoaderStatus(false);
      }

    } catch (error) {
      console.error("Error Deleting Users:", error);
      updateLoaderStatus(false);
      selectedUserNames([]);
      selectedUsers([]);
    }
  };

  const onClosenRefresh = () => {
    onRefreshData();
    setModalOpen(false);
  };

  const handleAddUser = async (e) => {
    e.preventDefault();

    if (!usernameInputRef.current.value.trim()) {
      if (usernameInputRef.current) {
        usernameInputRef.current.style.border = "1px solid red";
        toast.error("Username is required");
      }
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailValue = usernameInputRef.current.value.trim();

    if (!emailRegex.test(emailValue)) {
      usernameInputRef.current.style.border = "1px solid red";
      toast.error("Enter a valid email address");
      return;
    }

    try {
      if (usernameInputRef.current) {
        usernameInputRef.current.style.border = "";
      }
      updateLoaderStatus(true);
      const response = await addUser(usernameInputRef.current.value.trim(), securityGroupId);

      if (response !== null && response !== undefined) {
        // fetchUsers();
        toast.success("User added successfully");
        setModalOpen(false);
      }
      updateLoaderStatus(false);
    } catch (error) {
      console.error("Error adding user:", error);
      updateLoaderStatus(false);
    }
  };

  const sortTableData = (listData, sortConfig) => {
    var data = filterItems(listData, sortConfig);
    return data;
  };

  const handleSortClick = (direction, sortBy) => {
    setSortBy(sortBy);
    setSortDirection(direction);
    setCurentPageNbr(1);
  };

  const handleClick = (e, otherColumnName) => {
    setCurrentColumnName(otherColumnName);
    handleSortIconClick(
      e,
      defaultColumnName,
      otherColumnName,
      setSortBy,
      setDefaultColumnDirection,
      defaultColumnDirection,
      otherColumnDirection,
      setOtherColumnDirection,
      currentColumnName !== otherColumnName,
      handleSortClick
    );
  };

  const onPageNumberChange = (newPageNumber) => {
    setCurentPageNbr(newPageNumber);
  };

  const handleClosePopup = () => {
    setIsShowDeleteConfirmation(false);
  };

  const onPageSizeChange = (event) => {
    const pageSizeValue = event.target.value;
    setCurentPageNbr(1);
    setCurrentPageSize(parseInt(pageSizeValue));
  };
  const getPagerArea = () => {
    return (
      <Pager
        pageRecords={currentUsers === undefined ? 0 : currentUsers.length}
        totalRecords={userCountList.length}
        pageNumber={currentPageNbr}
        pageSize={currentPageSize}
        onPageNumberChange={onPageNumberChange}
        onPageChangeSize={onPageSizeChange}
        pageSizeOptions={[10, 20, 50, 100]}
        selectStyleClass={"no-border"}
        hidePageNumber={false}
        paginationRangeSeparator={"-"}
        keepAllPageOptions={true}
      ></Pager>
    );
  };

  return (
    <div className="user-tabs-content">
      <div className="top-bar">
        <SearchByInput onInputSearch={setSearch} />
        <div className="right-buttons d-flex align-items-center gap-3">
          <div className="buttonpopup">
            <div
              className="button  w-button flex"
              ref={toggleButtonRef}
              onClick={handleUserToggle}
            >
              User Actions
              <div className="down-arrow-white"></div>
            </div>
            <div ref={userRef}>
              {showUserPopup && (
                <>
                  <div className="prompt-popup-menu">
                    <div className="popup-row">
                      <div className="add-prompt-text"></div>
                      <Link
                        onClick={() => {
                          setShowUserPopup(false);
                          setModalOpen(true);
                        }}
                      >
                        Add User
                      </Link>
                    </div>
                    <div className="popup-row">
                      <div className="logout-icon"></div>
                      <Link to="/importusers"
                        state={{ securityGroupId: securityGroupId }}>Bulk Import</Link>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div
            className={
              selectedUsers?.length > 0
                ? "trash-button-icon light-gray-button"
                : "trash-button-icon light-gray-button disabled-element"
            }
          >
            <div className="trash-icon" onClick={() => handleDelete()}></div>
            <Link
              className={selectedUsers?.length > 0 ? "" : "disabled-div"}
              onClick={() => handleDelete()}
              to="#"
            >
              Delete
            </Link>
          </div>
        </div>
      </div>

      <div>
        <div className="user-table-list">
          <div className="user-table-row user-table-header">
            <div className="user-col auto-width">
              <input
                type="checkbox"
                ref={selectAllRef}
                onChange={handleSelectAll}
                checked={
                  selectedUsers.length === userList.length &&
                  userList.length > 0
                }
              />
            </div>

            <div
              className="user-col"
              direction={defaultColumnDirection}
              id="displayName"
              onClick={(e) => handleClick(e)}
              sortby={sortBy}
            >
              Name
              <SortButton
                direction={defaultColumnDirection}
                id="displayName"
                onClick={(e) => handleClick(e)}
                sortby={sortBy}
              ></SortButton>
            </div>
            <div
              className="user-col"
              direction={otherColumnDirection}
              id="UserName"
              onClick={(e) => handleClick(e, "UserName")}
              sortby={sortBy}
            >
              Username
              <SortButton
                direction={otherColumnDirection}
                id="UserName"
                onClick={(e) => handleClick(e, "UserName")}
                sortby={sortBy}
              ></SortButton>
            </div>
            <div
              className="user-col"
              direction={otherColumnDirection}
              id="role"
              onClick={(e) => handleClick(e, "role")}
              sortby={sortBy}
            >
              Role Type
              <SortButton
                direction={otherColumnDirection}
                id="role"
                onClick={(e) => handleClick(e, "role")}
                sortby={sortBy}
              ></SortButton>
            </div>
          </div>
          <div className="user-table-body">
            {currentUsers.length === 0 ? (
              <div className="no-users-found">No User(s) Found</div>
            ) : (
              currentUsers.map((user) => (
                <div key={user.userId} className="user-table-row">
                  <div className="user-col auto-width">
                    <input
                      type="checkbox"
                      checked={selectedUsers.includes(user.userId)}
                      onChange={() => {
                        handleSelectUser(user.userId);
                        handleSelectedUserName(user.UserName);
                      }}
                    />
                  </div>
                  <div className="user-col">{user.displayName}</div>
                  <div className="user-col">{user.UserName}</div>
                  <div className="user-col">{user.role ? user.role : "-"}</div>
                </div>
              ))
            )}
          </div>
          {currentUsers.length > 0 && (
            <div className="pagination-custom">{getPagerArea()}</div>
          )}
        </div>
      </div>
      {modalOpen && (
        <UserModal
          securityGroupId={securityGroupId}
          onClosenRefresh={() => onClosenRefresh()}
          isOwner={isOwner}
          onClose={() => setModalOpen(false)}
        />
      )}
      {isShowDeleteConfirmation && (
        <DeleteImportConfirmation
          handleClosePopup={handleClosePopup}
          handleDelete={removeUsers}
          selectedUsers={selectedUsers}
          isOwner={isOwner}
        />
      )}
    </div>
  );
};

export default UserOwnersMembers;
